import React, { useEffect, useState } from "react";
import "./basicDetails.scss";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material";
import brandStore from "../../../stores/brandStore";
import SnackbarAlert from "../../../components/snackbarAlert/snackbarAlert";
import snackbarStore from "../../../stores/snackbarStore";

// images
import uploadIcon from "../../../assets/logo.jpg";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { BRAND_IMAGE_URL } from "../../../constant";

const BasicDetails = () => {
  const BrandStore = brandStore();
  const SnackbarStore = snackbarStore();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    BrandStore.setFormData();
    BrandStore.clearValidation();
  }, []);

  const updateBrand = async () => {
    if (BrandStore.brandForm.brandName === "") {
      BrandStore.setValidate({ name: "brandName", value: true });
    } else {
      BrandStore.setValidate({ name: "brandName", value: false });
    }
    if (BrandStore.brandForm.brandEmail === "") {
      BrandStore.setValidate({ name: "brandEmail", value: true });
    } else {
      BrandStore.setValidate({ name: "brandEmail", value: false });
    }

    if (
      BrandStore.brandForm.brandName !== "" &&
      BrandStore.brandForm.brandEmail !== ""
    ) {
      setIsLoading(true);
      await BrandStore.updateBrand();
      setIsLoading(false);
    }
  };

  return (
    <div className="basicDetails">
      {/* for error */}
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        alertVariant="filled"
        alertSeverity="error"
        alertColor="error"
        massage={SnackbarStore.massage}
      />
      {/* for error */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container>
        <h2 className="title">Basic Details</h2>
      </Grid>
      <Grid container>
        <Grid
          container
          item
          lg={3}
          md={3}
          sm={12}
          xs={12}
          className="logo-container"
        >
          <Grid item xs={12}>
            <Grid item xs={12} className="brand-logo">
              <Box
                className="preview-brand-logo"
                component="img"
                src={
                  BrandStore.brandForm.brandLogoPreview
                    ? BrandStore.brandForm.brandLogoPreview
                    : BrandStore.brandForm.brandLogo
                    ? `${BRAND_IMAGE_URL}/${BrandStore.brandForm.brandLogo}`
                    : uploadIcon
                }
              />
              <Box
                className="hover-brand-logo"
                component="div"
                onClick={() =>
                  document.querySelector(".brand-logo-file").click()
                }
              >
                <AddPhotoAlternateIcon />
                <p>Upload Image</p>
              </Box>
              <input
                name="brandLogo"
                type="file"
                accept="image/*"
                className="brand-logo-file"
                hidden
                onChange={async (e) => {
                  const { files } = e.target;
                  const res = await BrandStore.fillBrandLogo({ files });
                  if (res === false) {
                    SnackbarStore.setMassage({
                      value: "File is to large.File must be less than is 1.5MB",
                    });
                    SnackbarStore.setIsOpen({ value: true });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} className="logo-title">
              <h2>Brand Logo</h2>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12} className="brand-details">
          <Grid container item spacing={2}>
            <Grid item xs={12} className="brand-name">
              <TextField
                fullWidth
                required
                error={BrandStore.validation.brandName}
                helperText={
                  BrandStore.validation.brandName && "Name is required"
                }
                name="brandName"
                label="Brand Name"
                value={BrandStore.brandForm.brandName}
                onChange={BrandStore.fillBrandDetails}
              />
            </Grid>
            <Grid item xs={12} className="brand-slogan">
              <TextField
                fullWidth
                name="brandSlogan"
                label="Slogan"
                value={BrandStore.brandForm.brandSlogan}
                onChange={BrandStore.fillBrandDetails}
              />
            </Grid>
            <Grid item xs={12} className="brand-email">
              <TextField
                fullWidth
                required
                error={BrandStore.validation.brandEmail}
                helperText={
                  BrandStore.validation.brandEmail && "Email is required"
                }
                name="brandEmail"
                label="Email"
                type="email"
                value={BrandStore.brandForm.brandEmail}
                onChange={BrandStore.fillBrandDetails}
              />
            </Grid>
            <Grid item xs={12} className="brand-contact-us">
              <TextField
                fullWidth
                name="brandContactUs"
                label="Contact us"
                value={BrandStore.brandForm.brandContactUs}
                onChange={BrandStore.fillBrandDetails}
              />
            </Grid>
            <Grid item xs={12} className="brand-address">
              <TextField
                fullWidth
                name="brandAddress"
                label="Address"
                multiline
                rows={3}
                value={BrandStore.brandForm.brandAddress}
                onChange={BrandStore.fillBrandDetails}
              />
            </Grid>
            <Grid item xs={12} className="brand-about">
              <TextField
                fullWidth
                name="brandAbout"
                label="About"
                multiline
                rows={3}
                value={BrandStore.brandForm.brandAbout}
                onChange={BrandStore.fillBrandDetails}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className="save-container">
        <Button className="btn" variant="contained" onClick={updateBrand}>
          <p>Save</p>
        </Button>
      </Grid>
    </div>
  );
};

export default BasicDetails;
